import React from 'react'

import { View } from '@amzn/stencil-react-components/layout'
import { Text } from '@amzn/stencil-react-components/text'
import { withTooltip } from '@amzn/stencil-react-components/tooltip'

const ViewWithTooltip = withTooltip<React.ComponentProps<typeof View>>()(View)

export const DEFAULT_BETA_TOOLTIP =
    'This feature is in beta. It may change, and your feedback helps us improve it.'

/**
 * Marks a feature as experimental, next to its heading or title. Hovering or focusing it explains
 * what beta means. Built like an extra-small Stencil chip, whose purple is too pale to stand out on
 * white.
 */
export function BetaChip({
    tooltipText = DEFAULT_BETA_TOOLTIP,
    dataTestId = 'beta-chip',
}: {
    tooltipText?: string
    dataTestId?: string
}) {
    return (
        <ViewWithTooltip
            tooltipText={tooltipText}
            dataTestId={dataTestId}
            display='inline-flex'
            alignItems='center'
            height='24px'
            padding={{ left: 'S200', right: 'S200' }}
            borderRadius='dimensions.border.radius.100'
            backgroundColor='color.purple.20'
        >
            <Text fontSize='T100' fontWeight='bold' color='color.purple.90'>
                Beta
            </Text>
        </ViewWithTooltip>
    )
}
